/*
 * @Description: 
 * @Version: 1.0
 * @Autor: zhangle
 * @Date: 2022-03-16 13:43:35
 * @LastEditors: zhangle
 * @LastEditTime: 2023-03-22 16:37:46
 */
import TsaDialog from '@/components/Dialog/index.vue'
let $vm
let watcher
let watcher1

const plugin = {
  install (vue, pluginOptions = {}) {
    const Dialog = vue.extend(TsaDialog)
    if (!$vm) {
      $vm = new Dialog({
        el: document.createElement('div')
      })
      document.body.appendChild($vm.$el)
    }

    const dialog = {
      show (options = {}) {
        watcher && watcher()
        watcher = $vm.$watch('statusConfirm', (val) => {
          val && options.onConfirm && options.onConfirm()
        })
        watcher1 && watcher1()
        watcher1 = $vm.$watch('statusCancel', (val) => {
          val && options.onCancel && options.onCancel()
        })
        $vm.show = true
        $vm['message'] = options['message']
        $vm['confirmBtnText'] = options['confirmBtnText'] || '确定'
        // Object.keys(options).map(key => {
        //   $vm[key] = options[key]
        // })
      },
      hide () {
        $vm.show = false
      }
    }
    if (!vue.prototype.$TsaDialog) {
      vue.prototype.$TsaDialog = dialog
    }
  }
}

export default plugin



// WEBPACK FOOTER //
// ./src/plugins/dialog/index.js